import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';

import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { ContasReceberService } from '../../../../../shared/services/apis/financas/contas-receber.service';
import { CategoriaFinanceira } from '../../../../../shared/services/models/financas/categoria-financeira.model';
import { ContasReceberBulkCategoriaRequest } from '../../../../../shared/services/requests/financas/contas-receber.request';
import { AlertCardComponent } from '../../../../../shared/components/alert-card/alert-card.component';

export interface AlterarCategoriaDialogData {
  idsContasReceberParcela: number[];
  categoriasFinanceiras: CategoriaFinanceira[];
}

@Component({
  selector: 'app-cr-alterar-categoria-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    AlertCardComponent,
  ],
  templateUrl: './alterar-categoria-dialog.component.html',
  styleUrls: ['./alterar-categoria-dialog.component.css'],
})
export class AlterarCategoriaDialogComponent implements OnInit {
  public model: FormGroup;
  public isLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private contasReceberService: ContasReceberService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<AlterarCategoriaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlterarCategoriaDialogData
  ) {}

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      idCategoriaFinanceira: [null, Validators.required],
    });
  }

  get idCategoriaFinanceiraControl(): FormControl {
    return this.model.get('idCategoriaFinanceira') as FormControl;
  }

  get qtdSelecionados(): number {
    return this.data.idsContasReceberParcela.length;
  }

  public confirmar(): void {
    if (this.isLoading) return;

    this.model.markAllAsTouched();
    if (this.model.invalid) {
      this.alertService.show('Atenção', 'Selecione uma categoria para continuar.', AlertType.warning);
      return;
    }

    const request: ContasReceberBulkCategoriaRequest = {
      idsContasReceberParcela: this.data.idsContasReceberParcela,
      idCategoriaFinanceira: this.model.getRawValue().idCategoriaFinanceira,
    };

    this.isLoading = true;
    this.contasReceberService.alterarCategoriaEmMassa(request).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Atenção', res.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show(
          'Sucesso',
          `Categoria atualizada em ${this.qtdSelecionados} parcela(s) com sucesso!`,
          AlertType.success
        );
        this.dialogRef.close(true);
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', err.message || err, AlertType.error);
      },
    });
  }

  public cancelar(): void {
    this.dialogRef.close(false);
  }
}
